export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-DZ": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-EG": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-LB": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-MA": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-SA": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-SY": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "ar-TN": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "bg-BG": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          }
        }
      },
      "bs-BA": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          }
        }
      },
      "cs-CZ": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          }
        }
      },
      "da-DK": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        }
      },
      "de-DE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-AT": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-CH": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-LU": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "el-GR": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        }
      },
      "el-CY": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        }
      },
      "en-GB": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            }
          }
        }
      },
      "en-IE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            }
          }
        }
      },
      "en-US": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            }
          }
        }
      },
      "es-ES": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          }
        }
      },
      "et-EE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          }
        }
      },
      "fi-FI": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          }
        }
      },
      "fr-BE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "fr-CH": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "fr-FR": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "fr-LU": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "ga-IE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          }
        }
      },
      "he-IL": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          }
        }
      },
      "hi-IN": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफल कार्रवाई"])}
            }
          }
        }
      },
      "hr-HR": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          }
        }
      },
      "hu-HU": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          }
        }
      },
      "it-CH": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione di successo"])}
            }
          }
        }
      },
      "it-IT": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          }
        }
      },
      "ja-JP": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          }
        }
      },
      "ko-KR": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성공적인 액션"])}
            }
          }
        }
      },
      "lt-LT": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          }
        }
      },
      "lv-LV": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          }
        }
      },
      "mt-MT": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          }
        }
      },
      "nb-NO": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        }
      },
      "nl-BE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        }
      },
      "nl-NL": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        }
      },
      "pl-PL": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          }
        }
      },
      "pt-PT": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          }
        }
      },
      "ro-RO": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          }
        }
      },
      "ru-RU": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          }
        }
      },
      "sk-SK": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          }
        }
      },
      "sl-SI": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          }
        }
      },
      "sv-SE": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          }
        }
      },
      "th-TH": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การดำเนินการที่ประสบความสำเร็จ"])}
            }
          }
        }
      },
      "tr-CY": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        }
      },
      "tr-TR": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        }
      },
      "uk-UA": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна дія"])}
            }
          }
        }
      },
      "vi-VN": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hành động thành công"])}
            }
          }
        }
      },
      "zh-CN": {
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          }
        }
      }
    }
  })
}
